<div class="batterie-container">
    @if (batteriePourcentage()) {
        <div id="batterie" class="pourcentage" style="--number: {{ batteriePourcentage() + 'px' }}"></div>
    } @else {
        <div id="batterie" [ngClass]="this.getIconClass()"></div>
    }
</div>
